import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const BackToLoginButton = () => {
  const navigate = useNavigate();

  const onClick = () => {
    void navigate('/login');
  };

  return (
    <ChakraV3.Button
      variant='plain'
      size='md'
      w='fit-content'
      cursor='pointer'
      fontWeight='semibold'
      onClick={onClick}
    >
      Back to login
    </ChakraV3.Button>
  );
};
